// toggle-navigation
// Show / Hide Navigation
//
// Author: tobias.wolf@wagnerwagner.de


(function () {
  // elements
  const element = document.querySelector('.toggle-navigation');
  const listElement = document.querySelector('.main-navigation__list');
  const bodyElement = document.querySelector('body');

  // variables

  // functions
  function updateListElement() {
    if (window.matchMedia('screen and (max-width: 927px)').matches) {
      if (bodyElement.classList.contains('navigation-is-open')) {
        listElement.hidden = false;
      } else {
        listElement.hidden = true;
      }
    } else {
      listElement.hidden = false;
    }
  }
  function updateBody() {
    if (window.matchMedia('screen and (max-width: 927px)').matches) {
      if (bodyElement.classList.contains('navigation-is-open')) {
        SCROLLING.scrollTop(null, 0, null, 250, () => {
          bodyElement.classList.add('no-scroll');
        });
      } else {
        bodyElement.classList.remove('no-scroll');
      }
    } else {
      bodyElement.classList.remove('no-scroll');
    }
  }
  function handleTransitionend(e) {
    if (e.propertyName === 'height') {
      updateListElement();
    }
  }
  function handleClick() {
    listElement.hidden = false;
    listElement.offsetHeight; // wait for .main-navigation__list-item to calculate transform
    bodyElement.classList.toggle('navigation-is-open');
    updateBody();
    listElement.addEventListener('transitionend', handleTransitionend);
  }
  function handleResize() {
    updateListElement();
    updateBody();
  }

  // event listener
  element.addEventListener('click', handleClick);
  window.addEventListener('resize', handleResize);

  [...listElement.querySelectorAll('button')].forEach((buttonElement) => {
    buttonElement.addEventListener('click', () => {
      listElement.hidden = true;
      bodyElement.classList.remove('navigation-is-open');
      bodyElement.classList.remove('no-scroll')
    });
  });

  // init
  updateListElement();
}());
